

import React from 'react';
import SimpleButton from './SimpleButton';
import SimpleButtonSettings from './SimpleButton.settings';
import { templateHelper } from '../../../template/helpers/templateHelper';

export const simpleButtonHandler = {
    tags,
    elementEditor,
    defaultStyle,
    component,
    settingsComponent,
    families
}

function component(element) {
    return <SimpleButton element={element} />
}
function settingsComponent(element) {
    return <SimpleButtonSettings />
}

function tags() {
    return {
        startTag: '<!-- 1 Column Text + Button : BEGIN -->',
        endTag: '<!-- 1 Column Text + Button : END -->'
    }
}

function families() {
    return [
        'button',
        'text'
    ]
}

function defaultStyle(templateStyle = null, defaultStyle = true) {
    const templateButtonStyle = templateStyle ? templateStyle.button : null;
    const templateContentStyle = templateStyle ? templateStyle.content : null;
    const inheritedStyles = templateStyle && !defaultStyle ? [
        "content.backgroundColor",
        "button.backgroundColor",
        "button.color",
        "button.borderRadius",
        "button.fontSize"
    ] : [];

    return {
        wrapper: {
            backgroundColor: templateContentStyle && !defaultStyle && templateContentStyle.backgroundColor ? templateContentStyle.backgroundColor : '#fffff',
        },
        elementProps: {
            text: 'Text',
            link: 'https://google.com/'
        },
        styleProps: {
            background: templateButtonStyle && !defaultStyle && templateButtonStyle.backgroundColor ? templateButtonStyle.backgroundColor : '#222222',
            border: templateButtonStyle && !defaultStyle ? borderStyle('1px solid #000000', templateButtonStyle.borderColor) : '1px solid #000000',
            fontFamily: 'sans-serif',
            fontSize: templateButtonStyle && !defaultStyle && templateButtonStyle.fontSize ? templateButtonStyle.fontSize : '15px',
            lineHeight: '15px',
            textDecoration: 'none',
            padding: '13px 17px 13px 17px',
            color: templateButtonStyle && !defaultStyle && templateButtonStyle.color ? templateButtonStyle.color : '#fff',
            display: 'block',
            borderRadius: templateButtonStyle && !defaultStyle && templateButtonStyle.borderRadius ? templateButtonStyle.borderRadius : '4px',
            margin: 'auto',
            minWidth: '150px',
            textAlign: 'center'
        },
        buttonClass: 'button-a button-a-primary',
        inheritedStyles: inheritedStyles
    }
}

function borderStyle(borderStyle, borderColor) {
    let borderParts = borderStyle.toString().split(' ');
    if (borderParts.length === 3) {
        borderParts[2] = borderColor;
        borderParts.join(' ');
        return borderParts;
    }
    return borderStyle;
}


function elementEditor(elementStyle, templateStyle = null, defaultStyle = true) {
    //Take what is relevant from the template
    const templateButtonStyle = templateStyle ? templateStyle.button : null;
    const templateContentStyle = templateStyle ? templateStyle.content : null;
    return (
        `
        <tr>
        <td style="background-color: ${templateContentStyle && !defaultStyle ? templateHelper.convertRgbStringToHex(templateContentStyle.backgroundColor) :
            templateHelper.convertRgbStringToHex(elementStyle.wrapper.backgroundColor)};">
            <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
        
        <td style="padding: 0 20px 0px;">
            <!-- Button : BEGIN -->
            <table align="center" role="presentation" cellspacing="0" cellpadding="0" border="0" style="margin: auto;">
                <tr>
                    <td class="button-td button-td-primary" style="border-radius: ${templateButtonStyle && !defaultStyle ? templateButtonStyle.borderRadius : elementStyle.styleProps.borderRadius};
                    background: ${templateButtonStyle && !defaultStyle ? templateHelper.convertRgbStringToHex(templateButtonStyle.backgroundColor)
            : templateHelper.convertRgbStringToHex(elementStyle.styleProps.background)};">
                         <a class="button-a button-a-primary"  href="${elementStyle.elementProps.link}"   style="
                         background:  ${templateButtonStyle && !defaultStyle ? templateButtonStyle.backgroundColor : elementStyle.styleProps.background};
                         border: 1px solid ${templateButtonStyle && !defaultStyle ? templateHelper.convertRgbStringToHex(templateButtonStyle.backgroundColor) :
            templateHelper.convertRgbStringToHex(elementStyle.styleProps.background)};
                          font-family:${elementStyle.styleProps.fontFamily}; 
                           font-size: ${templateButtonStyle && !defaultStyle ? templateButtonStyle.fontSize : elementStyle.styleProps.fontSize}; 
                          line-height: 15px; 
                           text-decoration: none; 
                           text-align: center;
                           width: ${elementStyle.styleProps.minWidth}; 
                           padding: 13px 17px; 
                           color: ${templateButtonStyle && !defaultStyle ? templateHelper.convertRgbStringToHex(templateButtonStyle.color)
            : templateHelper.convertRgbStringToHex(elementStyle.styleProps.color)}; 
                           display: block;
                           border-radius: ${templateButtonStyle && !defaultStyle ? templateButtonStyle.borderRadius : elementStyle.styleProps.borderRadius};">                    <span style="   color: ${templateButtonStyle && !defaultStyle ? templateHelper.convertRgbStringToHex(templateButtonStyle.color)
            : templateHelper.convertRgbStringToHex(elementStyle.styleProps.color)};  >
                           ${elementStyle.elementProps.text}
                           </span></a>
                    </td>
                </tr>
            </table>
            <!-- Button : END -->
        </td>
    </tr>

            </table>
        </td>
    </tr>
        
      `
    )
};

